import { DialogUtils } from "../../helper/dialog.helper";

// base-dialog.controller.ts
export class FiltersDialogController {
    private readonly $timeout: any;

    constructor($timeout: any) {
        this.$timeout = $timeout;
    }

    openDateRange(ev: any): void {
        let dp = document.getElementById("datepicker");
        let elem = dp.getElementsByClassName(
            "md-select-value"
        )[0] as HTMLElement;

        elem.click();

        this.$timeout(() => {
            const pickers = document.querySelectorAll("md-date-range-picker");
            const picker = pickers[pickers.length - 1] as HTMLElement;

            if (picker) {
                const container = picker?.parentElement
                    ?.parentElement as HTMLElement | null;

                if (container) {
                    container.style.cssText = `
                        position: fixed !important;
                        top: 50% !important;
                        left: 50% !important;
                        transform: translate(-50%, -50%) !important;
                        z-index: 100 !important;
                        margin: 0 !important;
                    `;
                }
            }
        }, 0);
    }
}
